const colorsPreset = {
  // Content colors
  "--content-base": "#FFFFFF",
  "--content-soft": "#A69E92",
  "--content-disabled": "#474642",
  // Informative colors
  "--informative-base": "#23B4C9",
  "--informative-50": "#ECFEFF",
  "--informative-100": "#CFFAFE",
  "--informative-200": "#A5F3FC",
  "--informative-300": "#67E8F9",
  "--informative-400": "#22D3EE",
  "--informative-500": "#06B6D4",
  "--informative-600": "#0891B2",
  "--informative-700": "#0E7490",
  "--informative-800": "#155E75",
  "--informative-900": "#164E63",
  "--informative-950": "#083344",
  // Warning colors
  "--warning-base": "#D67D39",
  "--warning-soft": "#A65028",
  "--warning-soft2": "#E8BC89",
  "--warning-strong": "#E8BC89",
  "--warning-bold": "#F9EDDB",
  "--warning-subtle": "#6C3722",
  "--warning-50": "#FCF7F0",
  "--warning-100": "#F9EDDB",
  "--warning-200": "#F1D7B7",
  "--warning-300": "#E8BC89",
  "--warning-400": "#E09F64",
  "--warning-500": "#D67D39",
  "--warning-600": "#C8672E",
  "--warning-700": "#A65028",
  "--warning-800": "#854027",
  "--warning-900": "#6C3722",
  "--warning-950": "#3A1A10",
  // Error colors
  "--error-base": "#EF4444",
  "--error-soft": "#B91C1C",
  "--error-strong": "#FCA5A5",
  "--error-bold": "#FEE2E2",
  "--error-subtle": "#7F1D1D",
  "--error-50": "#FEF2F2",
  "--error-100": "#FEE2E2",
  "--error-200": "#FECACA",
  "--error-300": "#FCA5A5",
  "--error-400": "#F87171",
  "--error-500": "#EF4444",
  "--error-600": "#DC2626",
  "--error-700": "#B91C1C",
  "--error-800": "#991B1B",
  "--error-900": "#7F1D1D",
  "--error-950": "#450A0A",
  // Success colors
  "--success-base": "#15A462",
  "--success-soft": "#14814F",
  "--success-strong": "#85F0BE",
  "--success-bold": "#DCFCEC",
  "--success-subtle": "#135438",
  "--success-50": "#F0FDF6",
  "--success-100": "#DCFCEC",
  "--success-200": "#BAF8DA",
  "--success-300": "#85F0BE",
  "--success-400": "#49DF99",
  "--success-500": "#21C97B",
  "--success-600": "#15A462",
  "--success-700": "#14814F",
  "--success-800": "#156642",
  "--success-900": "#135438",
  "--success-950": "#052E1D",
  // Dark Brand colors
  "--darkBrand-50": "#A69E92",
  "--darkBrand-100": "#999188",
  "--darkBrand-200": "#8B857D",
  "--darkBrand-300": "#7D7872",
  "--darkBrand-400": "#726E69",
  "--darkBrand-500": "#474642",
  "--darkBrand-600": "#333230",
  "--darkBrand-700": "#2E2D2C",
  "--darkBrand-800": "#1F1E1D",
  "--darkBrand-900": "#141414",
  "--darkBrand-950": "#0A0A0A",
  // Accent Brand colors
  "--accentBrand-50": "#FAEDCD",
  "--accentBrand-100": "#F2E4BF",
  "--accentBrand-200": "#E5D6AE",
  "--accentBrand-300": "#D9C89C",
  "--accentBrand-400": "#C7B587",
  "--accentBrand-500": "#B8A576",
  "--accentBrand-600": "#99815C",
  "--accentBrand-700": "#756041",
  "--accentBrand-800": "#5C4A2E",
  "--accentBrand-900": "#524531",
  "--accentBrand-950": "#524531",
  // Brand colors
  "--brand-50": "#E7D5FF",
  "--brand-100": "#FFF6E8",
  "--brand-200": "#FFEED5",
  "--brand-300": "#FFE1B3",
  "--brand-400": "#FDD598",
  "--brand-500": "#F8CC8B",
  "--brand-600": "#EBBE7A",
  "--brand-700": "#C49F66",
  "--brand-800": "#A9834A",
  "--brand-900": "#886736",
  "--brand-950": "#654B24",
  // Stroke colors
  "--stroke-base": "#474642",
  "--stroke-soft": "#333230",
  "--stroke-strong": "#726E69",
  "--stroke-error": "#EF4444",
  // Common Alpha colors
  "--commonAlpha-base": "#FFFFFF66",
  "--commonAlpha-soft": "#FFFFFF1A",
  "--commonAlpha-softer": "#FFFFFF0A",
  "--commonAlpha-inverseBase": "#00000066",
  "--commonAlpha-inverseStrong": "#00000099",
  // Refer Balls colors
  "--referBalls-basket1BgStart": "#FBBF24",
  "--referBalls-basket1BgStop": "#FBBF24",
  "--referBalls-basket1Label": "#FBBF24",
  "--referBalls-basket2BgStart": "#E09F64",
  "--referBalls-basket2BgStop": "#E09F64",
  "--referBalls-basket2Label": "#E09F64",
  "--referBalls-basket3BgStart": "#8A32EB",
  "--referBalls-basket3BgStop": "#8A32EB",
  "--referBalls-basket3Label": "#BA83FD",
  "--referBalls-basket4BgStart": "#00BCFF",
  "--referBalls-basket4BgStop": "#00BCFF",
  "--referBalls-basket4Label": "#00BCFF",
  "--referBalls-basket5BgStart": "#59549F",
  "--referBalls-basket5BgStop": "#59549F",
  "--referBalls-basket5Label": "#B8AEDA",
  "--referBalls-basketNormalBgStart": "#45408D",
  "--referBalls-basketNormalBgStop": "#45408D",
  "--referBalls-basketNormalLabel": "#8E89D1",
  // Background Images
  "--bg-header": "radial-gradient(720% 100.02% at 100% 38%, rgba(31, 30, 29, 0.96) 0%, rgba(20, 20, 20, 0.96) 100%)",
  "--bg-dialog": "radial-gradient(51.67% 51.19% at 51.67% 0%, #2E2D2C 0%, #141414 100%)",
  "--bg-homeBtn": "linear-gradient(180deg, #2E2D2C 0%, #1F1E1D 50.48%, #2E2D2C 100%)",
  "--bg-grdPrimary": "radial-gradient(50% 100% at 50% 0%, #B8A576 0%, #756041 100%)",
  "--bg-grdPrimaryAlt": "linear-gradient(180deg, #524531 0%, #5C4A2E 100%)",
  "--bg-grdSecondary": "radial-gradient(50% 100% at 50% 0%, #2E2D2C 0%, #1F1E1D 100%)",
  "--bg-grdSecondaryAlt": "linear-gradient(180deg, #2E2D2C 0%, #333230 100%)",
  "--bg-bottomMenu": "radial-gradient(33.48% 103.75% at 52.2% 0%, #886736 0%, #292218 100%)",
  "--bg-bottomNavBtnRound": "linear-gradient(180deg, #F8CC8B 0%, #5C4A2E 100%)",
  "--bg-bottomNavBtnRoundRimLight": "radial-gradient(50% 25% at 50% 100%, #FDD598 0%, rgba(41, 34, 24, 0.00) 100%)",
  "--bg-bottomNavBtnIndicatorActive": "radial-gradient(44.58% 50% at 50% 100%, #70623e 0%, #ffffff00 100%)",
  "--bg-bottomNavBtnIndicator": "",
  "--bg-pageTitle": "linear-gradient(180deg, #FFF 19.11%, #8B857D 71.43%)",
  "--bg-gradientTextBase": "linear-gradient(180deg, #FFF 19.11%, #8B857D 71.43%)",
  "--bg-tabNavSecondary": "linear-gradient(180deg,#2E2D2C 0%, #1F1E1D 100%)",
  "--bg-referFriendTopSection": "radial-gradient(73.33% 38.02% at 73.33% 58.07%, #7f694733 0%, rgba(0, 0, 0, 0.00) 100%)",
  "--bg-progressBarTray": "linear-gradient(180deg, #141414 0%, #1F1E1D 100%)",
  "--bg-timerProgressBar": "linear-gradient(90deg, #756041 0%, #C49F66 70%, #B7A575 100%)",
  "--bg-timerProgressStripes": "linear-gradient(-45deg,rgba(255,255,255,.20) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.20) 50%,rgba(255,255,255,.20) 75%,transparent 75%,transparent)",
  "--bg-card": "radial-gradient(46.81% 58.96% at 50% 0%,#333230 0%,#141414 100%)",
  "--bg-flipClock": "linear-gradient(180deg, #333230 0%, #2E2D2C 42%, #1F1E1D 46.5%, #141414 100%)",
  "--bg-grdHigh": "radial-gradient(71.88% 55.56% at 50% 0%, theme('backgroundColor.gradientTopHigh') 0%, theme('backgroundColor.gradientBottomHigh') 100%)",
  "--bg-grdMid": "radial-gradient(69.19% 53.57% at 50% 0%, theme('backgroundColor.gradientTopMid') 0%, theme('backgroundColor.gradientBottomMid') 100%)",
  "--bg-grdLow": "radial-gradient(69.19% 53.57% at 50% 0%, theme('backgroundColor.gradientTopLow') 0%, theme('backgroundColor.gradientBottomLow') 100%)",
  // Play and Spin background images
  "--bg-playAndSpinOverlay": "linear-gradient(270deg, rgba(31, 27, 79, 0.00) 0%, #1F1B4F 100%)",
  "--bg-playAndSpinItemEmpty": "linear-gradient(90deg, rgba(var(--darkBrand-800) / 0.00) 0%, rgba(var(--darkBrand-800)) 51.5%, rgba(var(--darkBrand-800)/ 0.00) 100%)",
  // Background Colors
  "--bg-backdrop": "#0A0A0AD9",
  "--bg-overlay": "#000000CC",
  "--bg-solidLow": "#333230",
  "--bg-gradientTopLow": "#333230",
  "--bg-gradientBottomLow": "#0A0A0A",
  "--bg-solidMid": "#333230",
  "--bg-gradientTopMid": "#333230",
  "--bg-gradientBottomMid": "#1F1E1D",
  "--bg-solidHigh": "#333230",
  "--bg-gradientTopHigh": "#333230",
  "--bg-gradientBottomHigh": "#2E2D2C",
  // Text Stylish Colors
  "--textStylish-strongGrdFrom": "#FDE68A",
  "--textStylish-strongGrdMid": "#fac855",
  "--textStylish-strongGrdTo": "#F59E0B"
};
const themeGoldNugget = {
  id: "gold-nugget",
  name: "Gold Nugget",
  className: "gold-nugget",
  colors: colorsPreset
};
export {
  colorsPreset,
  themeGoldNugget
};
